var map = {
	"./ic_bal_40.svg": 458,
	"./ic_btc_40.svg": 459,
	"./ic_crv_40.svg": 460,
	"./ic_dai_40.svg": 461,
	"./ic_eth_40.svg": 351,
	"./ic_frax_40.svg": 462,
	"./ic_fxs_40.svg": 463,
	"./ic_kcs_40.svg": 464,
	"./ic_klp_40.svg": 156,
	"./ic_kmx_40.svg": 288,
	"./ic_link_40.svg": 465,
	"./ic_mim_40.svg": 466,
	"./ic_ppusd_40.svg": 467,
	"./ic_tcr_40.svg": 468,
	"./ic_test_40.svg": 469,
	"./ic_uni_40.svg": 470,
	"./ic_usdc.e_40.svg": 471,
	"./ic_usdc_40.svg": 472,
	"./ic_usdt_40.svg": 473,
	"./ic_weth_40.svg": 474,
	"./ic_wkcs_40.svg": 475,
	"./ic_xkcs_40.svg": 476,
	"./ic_xusdt_40.svg": 477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 350;